export function mergeResolvedSerials({ fromProducts = [], fromLookup } = {}) {
  const found = fromLookup?.found || [];
  const missing = fromLookup?.missing || [];
  const by = new Map();
  for (const s of fromProducts) {
    if (s?.serialNumber) by.set(s.serialNumber, s);
  }
  for (const s of found) {
    if (s?.serialNumber && !by.has(s.serialNumber)) by.set(s.serialNumber, s);
  }
  const present = new Set(by.keys());
  return {
    serials: [...by.values()],
    missing: missing.filter((n) => !present.has(n)),
  };
}
